<template>
  <div>
    <div class="post-white-box">
      <h4 class="top-title">결재문서 원문공개</h4>
      <div class="top-white-box__form-wrapper">
        <div class="top-white-box__form">
          <div class="opengov-input-group">
            <div class="opengov-date-group clearfix">
              <div class="opengov-date">
                <datepicker name="startdate" :input-class="inputClass" v-model="startdate" :format="'yyyy.MM.dd'" placeholder="검색 시작일"></datepicker>
              </div>
              <div class="opengov-date opengov-date--last">
                <datepicker name="enddate" :input-class="inputClass" v-model="enddate" :format="'yyyy.MM.dd'" placeholder="검색 종료일"></datepicker>
              </div>
            </div>
            <input type="text" v-model="q" class="opengov-search-input" placeholder="검색어를 입력해주세요." title="검색어를 입력해주세요.">
            <input class="top-white-box__submit-btn" type="image" name="" src="/images/icon-white-search.png" alt="검색버튼" @click="search" title="검색버튼">
          </div>
        </div>
      </div>
    </div>
    <div v-if="isDetail" class="opengov-detail-wrapper">
      <div style="margin-bottom: 10px; text-align: right;">
        <button class="top-btn" @click="showList">목록</button>
      </div>
      <div class="opengov-detail-iframe-wrapper" style="margin-bottom: 60px;">
        <iframe width="1170" height="1000" :src="url" style="border: none;"></iframe>
      </div>
    </div>
    <div v-if="!isDetail">
      <div class="opengov-table-infos">
        <div class="opengov-total-count"><strong>전체:</strong> {{numberWithCommas(totalElements)}}건</div>
        <div class="load-count-btn">
          <button :class="`per-page-btn btn--light-gray--org ${perPageActive(50)}`" @click="changeDisplayCount(50)">50</button>
          <button :class="`per-page-btn btn--light-gray--org ${perPageActive(15)}`" @click="changeDisplayCount(15)">15</button>
        </div>
      </div>
      <ul class="campus-course-list-table">
        <li class="tr-wrapper tr-wrapper--th">
            <div class="th-normal">번호</div>
            <div class="th-normal">제목</div>
            <div class="th-normal">등록일자</div>
            <div class="th-normal th-normal--view-cnt">조회수</div>
        </li>
        <li class="tr-wrapper" v-for="post in posts">
          <div class="td-normal td-normal--first">
              <label class="td-normal__label">번호:</label>{{post.gvrnrgstnum}}</div>
          <div class="td-normal td-normal--opengov-title">
            <label class="td-normal__label">제목 :</label>
            <a class="post-box__title" @click="show(post.url)" title="{{post.title}}">{{post.title}}</a>
            <p class="opengov-desc">
              <span class="opengov-label city-label">{{post.gvrnname}}</span><span class="opengov-label ispublic-label">{{post.dlsrname}}</span>{{post.title}}
            </p>
            <p class="opengov-sub-desc">
              <span class="opengov-label part-label">{{post.brm_cl_all_nm}}</span>{{post.deptname}} &gt; {{post.kwrd}}
            </p>
          </div>
          <div class="td-normal">
            <label class="td-normal__label">등록일자 :</label>{{dateFormat(post.makedate)}}
          </div>
          <div class="td-normal">
            <label class="td-normal__label">조회수 :</label>{{post.view_count}}
          </div>
        </li>
      </ul>
      <div class="text-center" v-if="loading">
        <img src="/images/Rolling.svg" alt="롤링이미지">
      </div>
      <vue-pagination :size.sync="size" :totalElements="totalElements" :currentPage.sync="pageno"></vue-pagination>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import VueJsonp from 'vue-jsonp';
  import Datepicker from 'vuejs-datepicker';
  import VuePagination from '../shared/VuePagination.vue';

  Vue.use(VueJsonp, 5000);

  const MonChange = {
    Jan: '01',
    Feb: '02',
    Mar: '03',
    Apr: '04',
    May: '05',
    Jun: '06',
    Jul: '07',
    Aug: '08',
    Sep: '09',
    Oct: '10',
    Nov: '11',
    Dec: '12',
  };

  export default {
    name: 'open-gov-template',
    components: {
      Datepicker,
      VuePagination,
    },
    data() {
      return {
        MonChange,
        posts: [],
        startdate: '',
        enddate: '',
        q: '',
        inputClass: 'opengov-date-input',
        isDetail: false,
        gkey: '',
        url: '',
        size: 15,
        display: 15,
        pageno: 1,
        totalElements: 1,
        loading: false,
        sort: 'date',
      };
    },
    watch: {
      pageno() {
        this.getData();
      },
    },
    methods: {
      perPageActive(count) {
        if (count === this.display) {
          return 'active';
        }
        return '';
      },
      numberWithCommas(num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      },
      changeDisplayCount(count) {
        this.pageno = 1;
        this.display = count;
        this.size = count;
        this.getData();
      },
      dateReFormatter(date) {
        if (date) {
          const strDate = String(date);
          const year = strDate.substr(11, 4);
          const month = strDate.substr(4, 3);
          const day = strDate.substr(8, 2);
          return `${year}/${MonChange[month]}/${day}`;
        }
        return '';
      },
      getImageUrl(photoUrl) {
        return photoUrl || '/images/homepage/berry.jpg';
      },
      search() {
        this.pageno = 1;
        this.getData();
      },
      dateFormat(date) {
        return `${date.substr(0, 4)}.${date.substr(5, 2)}.${date.substr(8, 2)}`;
      },
      toArry(str) {
        return str.split(',');
      },
      getUrl(id) {
        return `/detail.do?id=${id}`;
      },
      showList() {
        this.isDetail = false;
        this.url = '';
      },
      show(urlValue) {
        this.isDetail = true;
        if (urlValue.substr(0, 5) !== 'https') {
          this.url = `${urlValue.substr(0, 4)}s${urlValue.substr(4)}`;
        } else {
          this.url = urlValue;
        }
      },
      getData() {
        this.loading = true;
        this.posts = [];
        const start = this.dateReFormatter(this.startdate);
        const end = this.dateReFormatter(this.enddate);
        this.$jsonp('https://opengov.seoul.go.kr/openapi?gvrncd=100220', {
          pageno: this.pageno,
          display: this.display,
          startdate: start,
          enddate: end,
          q: this.q,
          sort: this.sort,
        }).then((json) => {
          this.posts = json.item;
          this.totalElements = json.totalCount;
          this.loading = false;
        }).catch((err) => {
          alert(err.msg);
        });
      },
    },
    mounted() {
      this.getData();
    },
  };
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// OpenGov.vue?5d1bc9fe